import { Navigate } from "react-router-dom"
import { AppShell } from "components/dashboard/app-shell"
import { useUser, CurrentUser } from "contexts/UserContext"

export default function DashboardNewPage() {
  const { user, loading, setUser } = useUser()

  // Loading state
  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{
          background: `linear-gradient(to bottom right, var(--hexa-bg-gradient-start), var(--hexa-bg-gradient-mid), var(--hexa-bg-gradient-end))`,
        }}
      >
        <div className="text-lg" style={{ color: "var(--hexa-text-primary)" }}>
          Caricamento...
        </div>
      </div>
    )
  }

  // Se non c'è utente e non c'è token, reindirizza al login
  if (!user && !localStorage.getItem('accessToken')) {
    return <Navigate to="/login" replace />
  }

  // Handler per aggiornare user quando le impostazioni vengono salvate
  const handleUserUpdate = (updatedUser: CurrentUser) => {
    console.log("[DashboardNewPage] User updated:", updatedUser)
    setUser(updatedUser)
  }

  return <AppShell currentUser={user} onUserUpdate={handleUserUpdate} />
}
